import { withStyles } from '@material-ui/core';
import React from 'react';

import PropTypes from 'prop-types';

import DomainGroupingTextField from './domain-grouping-text-field';
import DomainGroupingTypeahead from './domain-grouping-typeahead';
import DomainMultiSelect from './domain-multi-select';

const styles = theme => {
    return  {
        absoluteContainer: {
            paddingRight: theme.spacing.unit * 6,
            position: 'absolute',
            width: '100%',
        },
        heightContainer: {
            height: 134
        }
    };
};

const DomainGroupingForm = ( {
    assignMode,
    classes,
    createDomainGroup,
    domains,
    domainGroups,
    editMode,
    onDomainChange,
    onGroupNameChange,
    onSelectedGroupChange,
    selectedDomains,
    selectedGroupId,
    selectedGroupName,
} ) => {

    return (
        <div className={classes.heightContainer}>
            <div className={classes.absoluteContainer}>
                {
                    editMode ? (
                        <DomainGroupingTextField
                            selectedGroupName={selectedGroupName}
                            setSelectedGroupName={onGroupNameChange}
                        />
                    ) : (
                        <DomainGroupingTypeahead
                            createNewGroup={createDomainGroup}
                            domainGroups={domainGroups}
                            selectedGroupId={selectedGroupId}
                            selectedGroupName={selectedGroupName}
                            setSelectedGroupId={onSelectedGroupChange}
                            setSelectedGroupName={onGroupNameChange}
                            setSelectedDomains={onDomainChange}
                            assignMode={assignMode}
                        />
                    )}
                <DomainMultiSelect
                    isDisabled={!selectedGroupName}
                    domains={domains}
                    selectedDomains={selectedDomains}
                    setSelectedDomains={onDomainChange}
                />
            </div>
        </div>
    );
};

DomainGroupingForm.propTypes = {
    assignMode: PropTypes.bool.isRequired,
    classes: PropTypes.object,
    createDomainGroup: PropTypes.func,
    domainGroups: PropTypes.array,
    domains: PropTypes.array,
    editMode: PropTypes.bool.isRequired,
    onDomainChange: PropTypes.func.isRequired,
    onGroupNameChange: PropTypes.func.isRequired,
    onSelectedGroupChange: PropTypes.func.isRequired,
    selectedDomains: PropTypes.array,
    selectedGroupId: PropTypes.number,
    selectedGroupName: PropTypes.string,
};

export default withStyles( styles )( DomainGroupingForm );
